// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1688":"05c769be","3776":"bf0ee7a6","7188":"bf0ee7a6","8496":"bf0ee7a6"}[chunkId] + ".chunk.css";
};